import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import FalconCardHeader from 'components/common/FalconCardHeader';
import axios from 'api/axios';
import ModalAlert from 'components/mycomponents/ModalAlert';

const ProfileSettings = () => {
  const [formData, setFormData] = useState({
    vcname: 'Anthony',
    email: 'anthony@gmail.com',
    phone: '+44098098304',
  });
  const [loadingData, setLoadingData] = useState(false);
  const [showAlert, setShowAlert] = useState({show: false, message: '', type: '', confirmButton: false});

  // Declare Constant Variable
  const navigate = useNavigate();
  const DATA_URL = '/users';
  const ACCESS_USER = JSON.parse(localStorage.getItem('accessUser'));
    const TOKEN_APP = ACCESS_USER ? ACCESS_USER.token : '';
    const HEADER_AUTHORIZATION = {
        headers: {
          'Authorization': `Bearer ${TOKEN_APP}`
        }
    };

  // function get data
  const getData = async () => {
    setLoadingData(true);
    try {
      const response = await axios.get(`${DATA_URL}/${ACCESS_USER.user_id}`, HEADER_AUTHORIZATION);
      const responseData = response.data;
      setFormData({
        ...formData,
        vcname: responseData.data.vcname,
        email: responseData.data.vcemail,
        phone: responseData.data.vcphone,
      });
      console.log(responseData);
      // const dataTemp = {
      //     intid: responseData.data.intid,
      //     vccode: responseData.data.vccode,
      //     vcname: responseData.data.vcname,
      // }
        
    } catch (err) {
        setLoadingData(false);
        if (err.response) {
            if (err?.response.status === 401) {
                toast.error(err?.response.data.message);
                localStorage.removeItem('accessUser');
                navigate('/login');
            } else {
                const response = err.response.data;
                setShowAlert(prevState => { return {...prevState, show: true, message: response.message, type: 'error'} })
            }
        } else {
            setShowAlert(prevState => { return {...prevState, show: true, message: 'Something error with server. Please call administrator or developer.', type: 'error'} })
        }
    }
}

// Get Data On Load
useEffect(() => {
    getData();
// eslint-disable-next-line react-hooks/exhaustive-deps
}, []);

  const handleChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = e => {
    e.preventDefault();
  };

  const handleConfirmAlert = () => {
    setShowAlert(prevState => { return {...prevState, show: false}});
}

const updateData = async () => {
  try {
      const dataPut = formData;
      dataPut.user_id = ACCESS_USER.user_id

      const response = await axios.put(`${DATA_URL}/${ACCESS_USER.user_id}`, dataPut, HEADER_AUTHORIZATION);
      const responseData = response.data;
      setLoadingData(false);
      toast.success(`${responseData.message}`, {
          theme: 'colored',
          position: "top-center"
      });
      getData();
  } catch (err) {
      setLoadingData(false);
      if (err.response) {
          if (err?.response.status === 401) {
              toast.error(err?.response.data.message);
              localStorage.removeItem('accessUser');
              navigate('/login');
          } else {
              const response = err.response.data;
              setShowAlert(prevState => { return {...prevState, show: true, message: response.message, type: 'error'} })
          }
      } else {
          setShowAlert(prevState => { return {...prevState, show: true, message: 'Something error with server. Please call administrator or developer.', type: 'error'} })
      }
  }
}

  return (
    <>
      <Card loadingData={loadingData}>
        <FalconCardHeader title="Profile Settings" />
        <Card.Body className="bg-light">
          <Form onSubmit={handleSubmit}>
            <Row className="mb-3 g-3">
              <Form.Group as={Col} lg={12} controlId="name">
                <Form.Label>Nama</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Nama"
                  value={formData.vcname}
                  name="vcname"
                  onChange={handleChange}
                />
              </Form.Group>
            </Row>
            <Row className="mb-3 g-3">
              <Form.Group as={Col} lg={6} controlId="email">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Email"
                  value={formData.email}
                  name="email"
                  onChange={handleChange}
                />
              </Form.Group>

              <Form.Group as={Col} lg={6} controlId="phone">
                <Form.Label>Phone</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Phone"
                  value={formData.phone}
                  name="phone"
                  onChange={handleChange}
                />
              </Form.Group>
            </Row>
            <div className="text-end">
              <Button variant="primary" onClick={updateData}>
                Update
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
      <ModalAlert 
          type={showAlert.type}
          show={showAlert.show}
          message={showAlert.message}
          onHide={() => setShowAlert(prevState => { return {...prevState, show: false} })}
          onConfirm={handleConfirmAlert}
          confirmButton={showAlert.confirmButton}
      />
    </>
  );
};

export default ProfileSettings;
